import { MetadataContext, ModuleBase, ResponsiveImage, RichText } from '@/components';
import { ImageModel, ModuleBaseModel, ModuleBasePropsModel } from '@/types';
import { useContext } from 'react';

type BlurredContentModel = ModuleBaseModel<
  {
    text: string;
    leftImage: ImageModel;
    rightImage: ImageModel;
  } & ModuleBasePropsModel
>;

const BlurredContent = (data: BlurredContentModel) => {
  const {
    props: { text, leftImage, rightImage },
  } = data;

  const metadataContext = useContext(MetadataContext);

  return (
    <ModuleBase data={data}>
      <div className="container">
        <div className="flex flex-col">
          <h2 className="text-h4 pb-10 text-center font-bold">{metadataContext.pageTitle}</h2>

          <RichText className="blur-[3px]" data={text} />
          <div className="mt-6 flex w-full flex-col gap-6 md:flex-row">
            {leftImage && (
              <div className="aspect-video w-full md:w-1/2">
                <ResponsiveImage
                  image={leftImage}
                  widths={{ xs: 386, sm: 580, md: 384, lg: 476, xl: 700, xxl: 1000 }}
                  heights={{ xs: 216, sm: 329, md: 200, lg: 268, xl: 400, xxl: 500 }}
                />
              </div>
            )}
            {rightImage && (
              <div className="aspect-video w-full md:w-1/2">
                <ResponsiveImage
                  image={rightImage}
                  widths={{ xs: 386, sm: 580, md: 384, lg: 476, xl: 700, xxl: 1000 }}
                  heights={{ xs: 216, sm: 329, md: 200, lg: 268, xl: 400, xxl: 500 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </ModuleBase>
  );
};

export default BlurredContent;
